export enum GiftProductInputFormConstants {
  SenderName = 'senderName',
  SenderEmailAddress = 'senderEmailAddress',
  RecipientName = 'recipientName',
  RecipientEmailAddress = 'recipientEmailAddress',
  GiftMessage = 'giftMessage',
}
